import NetworkError from '@/helpers/errors/networkError';
import ApiError from '@/helpers/errors/apiError';
import UnknownError from '@/helpers/errors/unknownError';

function isNetworkError(err) {
  return err.isAxiosError && !err.response;
}

function isApiError(err) {
  return err.isAxiosError && err.response;
}

export default (error, ctx) => {
  // Network error
  if (isNetworkError(error)) {
    return new NetworkError(error, ctx);
  }

  // API error
  if (isApiError(error)) {
    return new ApiError(error, ctx);
  }

  // Unknown error
  return new UnknownError(error, ctx);
};
